import posthog from 'posthog-js'

import { useSharedAnalyticsStore } from '../stores/analytics'

export function useAnalytics() {
  const analyticsStore = useSharedAnalyticsStore()

  function trackStageOpened(surface = 'stage-web') {
    if (analyticsStore.stageOpenedTracked)
      return

    analyticsStore.markStageOpenedTracked()
    posthog.capture('stage_opened', {
      surface,
    })
  }

  function trackVoiceUsed(mode: 'stream' | 'vad' | 'manual' = 'vad') {
    if (analyticsStore.voiceUsedTracked)
      return

    analyticsStore.markVoiceUsedTracked()
    posthog.capture('voice_used', {
      mode,
    })
  }

  function trackProviderClick(providerId: string, module: string) {
    posthog.capture('provider_card_clicked', {
      provider_id: providerId,
      module,
    })
  }

  function trackFirstMessage() {
    // Only track the first message once
    if (analyticsStore.firstMessageTracked)
      return

    analyticsStore.markFirstMessageTracked()

    // Calculate time from app start to message sent
    const timeToFirstMessageMs = analyticsStore.appStartTime
      ? Date.now() - analyticsStore.appStartTime
      : null

    posthog.capture('first_message_sent', {
      time_to_first_message_ms: timeToFirstMessageMs,
    })
  }

  function trackSessionRound(round: number) {
    if (round <= analyticsStore.roundsTracked)
      return

    analyticsStore.setRoundsTracked(round)
    posthog.capture('message_round', {
      round,
      milestone: round % 4 === 0,
    })
  }

  function trackPricingClick(plan: 'free' | 'pro', source = 'landing') {
    posthog.capture('pricing_click', {
      plan,
      source,
    })
  }

  function trackSubscriptionClick(plan: 'free' | 'pro', source = 'landing', action: 'intent' | 'checkout' = 'checkout') {
    posthog.capture('subscription_click', {
      plan,
      source,
      action,
    })
  }

  function trackCheckoutSuccess(plan: 'free' | 'pro', source = 'landing', provider = 'stripe') {
    posthog.capture('checkout_success', {
      plan,
      source,
      provider,
    })
  }

  function trackMemoryHitShown(source = 'chat-memory', eventCount = 0) {
    posthog.capture('memory_hit_shown', {
      source,
      event_count: eventCount,
    })
  }

  return {
    trackStageOpened,
    trackVoiceUsed,
    trackProviderClick,
    trackFirstMessage,
    trackSessionRound,
    trackPricingClick,
    trackSubscriptionClick,
    trackCheckoutSuccess,
    trackMemoryHitShown,
  }
}
